import axios from "axios"
import cookie from 'js-cookie'
import { showToast } from ".";

export const request = axios.create({
  baseURL: import.meta.env.MODE !== 'development' ? import.meta.env.VITE_APP_API_URL_PUBLIC : import.meta.env.VITE_APP_API_URL,
  timeout: 20000,
  withCredentials: true,
  headers: {
    'X-CSRFToken': cookie.get('csrftoken')
  }
});

// request.interceptors.request.use(function (config) {
//   // Do something before request is sent (Add animation...)
//   return config;
// }, function (error) {
//   // Do something with request error
//   return Promise.reject(error);
// });

request.interceptors.response.use((response) => {
  // if(response?.data?.status != config?.statusSuccess && response?.data?.payload?.error_code != 'not_auth') {
  //   if(response?.data?.payload?.error_code == 'no_account') {
  //     showDownload()
  //   } else {
  //     let errCode = response?.data?.payload?.error_code
  //     showToast(lng[errCode] ? lng[errCode] : (`${lng.defaultError} [${errCode}]`))
  //   }
  // }
  return response?.data
}, (error) => {
  // if(error?.code === 'ERR_BAD_REQUEST') {
  //   notifications.show({
  //     message: `${i18n.t('error.title')} ${i18n.t('error.notFoundAPI')}`,
  //     // autoClose: false
  //   })
  // }
  if(error?.message === 'Network Error' || error?.code === 'ECONNABORTED') {
    showToast(`Mất kết nối tới máy chủ`)
  }
  return Promise.reject(error);
});